<template>
  <div>
    <div class="parent" :style="style" :class="[!showDetails ? 'parent-2' : '']">
      <v-card @click="showCoursefun">
        <v-card-title class="info-title" :style="[
          !showFullInfo && isMobile && showDetails
            ? { 'border-radius': '15px' }
            : '',
        ]">
          <font-awesome-icon v-if="showDetails && isMobile" class="collapse"
            :icon="showFullInfo ? 'angle-down' : 'angle-left'" />
          <div class="text-center" :style="elipsisStyle">
            <div v-if="!showDetails || !isMobile">
              دوره {{ classes.CycleID }}: {{ classes.CycleName }}
            </div>
            <div v-else style="text-overflow: ellipsis;overflow: hidden;">
              {{ classes.TitleName }}
            </div>
          </div>
        </v-card-title>
        <div>
          <template v-if="!showDetails || !isMobile">
            <app-row icon="university" title="مدرسه:" :value="classes.SchoolName" />
            <app-row icon="book" title="درس:" :value="classes.TitleName" />
            <app-row icon="hashtag" title="کد کلاس:" :value="classes.ClassID" />

          </template>
          <template v-if="showDetails && (showFullInfo || !isMobile)">
            <app-row icon="calendar-alt" title="تاریخ:" :value="date" />
            <app-row icon="clock" title="ساعت:" :value="getClock" :showButton="true" buttonText="تغییر تاریخ"
              :showButton2="true" buttonText2="جزییات" @clicked="$emit('onClickDate')"
              @clicked2="$emit('onShowDetail')" />
          </template>
          <template v-else-if="!showDetails">
            <app-row icon="user-circle" title="استاد:" :value="classes.TeacherName" />
            <app-row icon="hashtag" title="تعداد کلاس برگزار شده:" :value="classes.ClassCount" />
          </template>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import DetailRow from "@/components/DetailRow";
export default {
  props: [
    "classes",
    "index",
    "selectedCourse",
    "selectedVahed",
    "showDetails",
    "date",
    "sessionInfo",
    "showFullInfo",
  ],
  components: {
    appRow: DetailRow,
  },
  /**
   * open hozoor list
   */
  methods: {
    showCoursefun() {
      if (!this.showDetails) {
        this.$emit("clicked", this.index);
      } else {
        this.$emit("clicked");
      }
    },
  },

  computed: {
    style() {
      var res = "";
      if (this.showDetails) {
        res += "position: fixed";
        if (this.$store.getters.isMobile) {
          res +=
            "width: 100%;background-color: rgb(232,232,232) !important; box-shadow: unset";
        } else {
          res +=
            "width: calc(100% - 300px);background-color: white !important;";
        }
      }
      return res;
    },
    elipsisStyle() {
      var res = "";
      if (this.showDetails && this.isMobile) {
        res += "width: 100%;  white-space: nowrap;";
      }
      return res;
    },
    getClock() {
      return this.sessionInfo.Start
        ? `از ساعت ${this.sessionInfo.Start} تا ساعت ${this.sessionInfo.End}`
        : "";
    },
    isMobile() {
      return this.$store.getters.isMobile;
    },
  },

  created() { },
};
</script>
<style>
.vpd-input-group {
  z-index: 5 !important;
}
</style>
